/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RequestOtpModel } from '../../models/request-otp-model';
import { RequestOtpResponseModel } from '../../models/request-otp-response-model';

export interface LocalAccountRequestOtpPost$Params {
      body?: RequestOtpModel
}

export function localAccountRequestOtpPost(http: HttpClient, rootUrl: string, params?: LocalAccountRequestOtpPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<RequestOtpResponseModel>> {
  const rb = new RequestBuilder(rootUrl, localAccountRequestOtpPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<RequestOtpResponseModel>;
    })
  );
}

localAccountRequestOtpPost.PATH = '/LocalAccount/RequestOTP';
